import { decodeSegment } from "./matching/decode-segment.ts";
import { isMatchedRoute } from "./matching/is-matched-route.ts";
import { matchGameRoute } from "./matching/match-game-route.ts";
import { matchStaticRoute } from "./matching/match-static-route.ts";
import { unknownRoute, type MatchedRoute } from "./matching/matched-route.ts";

export function matchRoute(pathname: string): MatchedRoute {
  if (
    !pathname.startsWith("/") ||
    pathname.includes("//") ||
    /[?#]/.test(pathname)
  )
    return unknownRoute;

  const raw = pathname.split("/").slice(1);

  if (raw.at(-1) === "") raw.pop();

  const parts: string[] = [];

  for (const segment of raw) {
    const decoded = decodeSegment(segment);

    if (!decoded) return unknownRoute;

    parts.push(decoded);
  }

  const match = matchStaticRoute({ parts, raw }) ?? matchGameRoute(parts);

  if (match === null) return unknownRoute;

  if (isMatchedRoute(match)) return match;

  throw new Error(`Invalid parameters for route ${match.name}`);
}
